<div class="roulette-modal">
  @if(!spinning && !emailStep && !loadingNextSpin) {
  <button class="roulette-close" type="button" (click)="touchClose()" aria-label="Fechar">
    <ion-icon name="close"></ion-icon>
  </button>
  } @if(badgeText) {
  <span class="roulette-badge">{{ badgeText }}</span>
  } @if(title) {
  <h2 class="roulette-title">{{ title }}</h2>
  } @if(message) {
  <p class="roulette-message">{{ message }}</p>
  }

  <div class="roulette-stage">
    <div class="roulette-rotor" #rotor>
      <svg viewBox="0 0 200 200" class="roulette-wheel">
        <circle cx="100" cy="100" r="98" class="roulette-rim"></circle>

        @for(dot of dots; track $index) {
        <circle [attr.cx]="dot.x" [attr.cy]="dot.y" r="2.3" class="roulette-dot" [class.is-light]="dot.light"></circle>
        } @for(sector of sectors; track sector.prize.id) {
        <path [attr.d]="sector.path" class="roulette-sector"></path>
        } @for(sector of sectors; track sector.prize.id) {
        <line x1="100" y1="100" [attr.x2]="sector.divider.x" [attr.y2]="sector.divider.y" class="roulette-divider"></line>
        } @for(sector of sectors; track sector.prize.id) { @if(sector.prize.imageUrl) {
        <image
          [attr.href]="sector.prize.imageUrl"
          [attr.x]="sector.icon.x - 8"
          [attr.y]="sector.icon.y - 8"
          width="16"
          height="16"
          preserveAspectRatio="xMidYMid meet"
        ></image>
        } @else {
        <path [attr.d]="starburstPath" [attr.transform]="'translate(' + sector.icon.x + ' ' + sector.icon.y + ')'" class="roulette-icon"></path>
        }

        <text
          class="roulette-label"
          text-anchor="middle"
          dominant-baseline="middle"
          [attr.y]="sector.label.y - ((sector.labelLines.length - 1) * labelLineHeight) / 2"
        >
          @for(line of sector.labelLines; track $index) {
          <tspan [attr.x]="sector.label.x" [attr.dy]="$first ? 0 : labelLineHeight">{{ line }}</tspan>
          }
        </text>
        }
      </svg>
    </div>

    <svg viewBox="0 0 200 200" class="roulette-fixed" aria-hidden="true">
      <path d="M100 13.5 L93.5 8 A8.3 8.3 0 1 1 106.5 8 Z" class="roulette-pointer"></path>
      <circle cx="100" cy="2.8" r="2.4" class="roulette-pointer-dot"></circle>

      <circle cx="100" cy="100" r="18.5" class="roulette-hub"></circle>
      <text x="100" y="100.5" text-anchor="middle" dominant-baseline="middle" class="roulette-hub-label">TIME</text>
    </svg>
  </div>

  <p class="roulette-spins-text">Roletadas disponíveis hoje: {{ availableSpins }}</p>

  <button class="roulette-spin" type="button" (click)="touchSpin()" [disabled]="spinning || hasSpun || !canSpin || sectors.length < 2">
    {{ spinning ? 'GIRANDO...' : 'GIRAR' }}
  </button>

  <button class="roulette-rules" type="button">Ver regras</button>

  @if(result) {
  <div class="roulette-result">
    <div class="roulette-result-box">
      <h2>Seu prêmio</h2>
      @if(result.imageUrl) {
      <img [src]="result.imageUrl" [alt]="result.label" />
      }
      <p>{{ result.label }}</p>
      @if(emailStep === 'confirm') {
      <span class="roulette-email-hint">Este é o seu e-mail?</span>
      <strong class="roulette-email">{{ userEmail }}</strong>
      <button class="roulette-spin" type="button" (click)="touchConfirmEmail()">CONFIRMAR</button>
      <button class="roulette-email-link" type="button" (click)="touchEditEmail()">ALTERAR E-MAIL</button>
      } @else if(emailStep === 'edit') {
      <label class="roulette-email-hint" for="roulette-email-input">Informe o seu e-mail</label>
      <input
        id="roulette-email-input"
        class="roulette-email-input"
        type="email"
        inputmode="email"
        autocomplete="email"
        [(ngModel)]="newEmail"
        [disabled]="savingEmail"
      />
      <button class="roulette-spin" type="button" (click)="touchSaveEmail()" [disabled]="savingEmail">
        {{ savingEmail ? 'SALVANDO...' : 'SALVAR' }}
      </button>
      @if(userEmail) {
      <button class="roulette-email-link" type="button" (click)="touchCancelEditEmail()" [disabled]="savingEmail">VOLTAR</button>
      } }
    </div>
  </div>
  }
</div>
